<template>
    <el-container :class="{'is-authenticated': $store.getters.isAuthenticated && $route.name !== 'activation'}">
        <MobileSidebar v-if="mobileSidebarVisible" v-on:close="mobileSidebarVisible = false" />
        <el-header height="180">

            <div class="toggle-nav" v-if="$store.getters.isAuthenticated">
                <span @click="mobileSidebarVisible=!mobileSidebarVisible"><i class="material-icons md-24">list</i><el-badge class="mark" is-dot v-if="$store.getters.getNewsUnread || $store.getters.getTicketUnread" /></span>
            </div>

            <div class="logo">
                <span><a href="/"><img src="./assets/logo.svg" alt=""></a></span>
            </div>
            <div class="title"><span v-if="$route.meta.title">{{ $t($route.meta.title) }}</span></div>

            <div class="balance" v-if="$route.meta.requiresAuth">
                <el-popover
                        placement="bottom-start"
                        width="160"
                        trigger="hover">
                    <div style="text-align: center">{{ $t('balance') }}: {{ $store.getters.getUser.balance | n(2, '$') }}</div>
                    <div style="text-align: center">{{ $t('hold') }}: {{ $store.getters.getUser.balance_hold | n(2, '$') }}</div>
                    <div slot="reference" class="balance-item"><img src="./assets/wallet.svg">{{ $store.getters.getUser.balance | n(2, '$') }}</div>
                </el-popover>

              <el-popover
                  placement="bottom-start"
                  width="160"
                  trigger="hover">
                <div style="text-align: center">{{ $t('balance') }}: {{ $store.getters.getUser.rub_balance || 0 | n(2, '₽') }}</div>
                <div style="text-align: center">{{ $t('hold') }}: {{ $store.getters.getUser.rub_balance_hold || 0 | n(2, '₽') }}</div>
                <div slot="reference" class="balance-item"><img src="./assets/wallet.svg">{{ $store.getters.getUser.rub_balance || 0 | n(2, '₽') }}</div>
              </el-popover>
            </div>
            <div class="lang">
                <ChangeLocale />
            </div>

            <div class="user" v-if="$route.meta.requiresAuth">
                <el-dropdown>
                    <span class="el-dropdown-link"><img src="./assets/cover-blank.png" class="avatar" :style="{backgroundImage: `url('${$store.getters.getUser.avatar || require('./assets/avatar.png')}')`}" />{{$store.getters.getUser.email}}<i class="el-icon-arrow-down el-icon--right"></i></span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="$router.push('/profile')">{{ $t('profile') }}</el-dropdown-item>
                        <el-dropdown-item @click.native="$router.push('/referrals')">{{ $t('referrals') }}</el-dropdown-item>
                        <el-dropdown-item divided @click.native="logout">{{ $t('logout') }}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </el-header>

        <div class="sidebar" v-if="$route.meta.requiresAuth">
            <el-menu mode="vertical" :default-active="$route.path" router>
                <el-menu-item index="/statistic"><i class="material-icons md-24">equalizer</i> {{ $t('statistics') }}</el-menu-item>
                <el-menu-item index="/offers"><i class="material-icons md-24">&#xe87d;</i> {{ $t('offers') }}</el-menu-item>
                <el-menu-item index="/streams"><i class="material-icons md-24">link</i> {{ $t('streams') }}</el-menu-item>
                <el-menu-item index="/payments"><i class="material-icons md-24">&#xe850;</i> {{ $t('payments') }}</el-menu-item>
<!--                <el-menu-item index="/news"><i class="material-icons md-24">start_rate</i> {{ $t('news') }}<el-badge class="mark" is-dot :value="$store.getters.getNewsUnread" v-if="$store.getters.getNewsUnread" /></el-menu-item>-->
                <el-menu-item index="/profile"><i class="material-icons md-24">settings</i> {{ $t('setting') }}</el-menu-item>
                <el-menu-item index="/referrals"><i class="material-icons md-24">person</i> {{ $t('referrals') }}</el-menu-item>
                <el-menu-item index="/postback"><i class="material-icons md-24">assignment</i> {{ $t('postback_logs') }}</el-menu-item>
                <el-menu-item index="/tickets"><i class="material-icons md-24">chat</i> {{ $t('support') }}<el-badge class="mark" is-dot :value="$store.getters.getTicketUnread" v-if="$store.getters.getTicketUnread" /></el-menu-item>
                <el-menu-item index="/help"><i class="material-icons md-24">help</i> {{ $t('help') }}</el-menu-item>
            </el-menu>
        </div>

        <AdBlockDetected />
        <el-main>
            <router-view></router-view>
        </el-main>
        <el-footer height="40px">
            <el-row>
                <el-col :span="12">
                    <div class="footer-main footer-contact">
                        <img src="./assets/close-envelope.svg" style="height: 20px; margin-right: 7px" /><a href="mailto:support@lovepartners.biz">support@lovepartners.biz</a>
                    </div>
                    <div class="footer-main footer-contact">
                        <img src="./assets/telegram.svg" style="height: 20px; margin-right: 7px" /><a href="tg://resolve?domain=lovepartnersbiz">@lovepartnersbiz</a>
                    </div>
                </el-col>
                <el-col :span="12" style="text-align: right">

                </el-col>
            </el-row>
        </el-footer>

    </el-container>
</template>

<script>
    import ChangeLocale from "./components/layout/ChangeLocale";
    import MobileSidebar from "./components/MobileSidebar";
    import AdBlockDetected from "./components/AdBlockDetected";

    export default {
        name: 'app',
        components: {
            AdBlockDetected,
            MobileSidebar,
            ChangeLocale
        },
        data: () => ({
            mobileSidebarVisible: false,
            title: null,
            current_year: new Date().getFullYear()
        }),
        created () {
            this.getUser();

            this.intervalid = setInterval(() => {
                this.getUser();
            }, 10000);
        },
        watch: {
            '$store.getters.isAuthenticated': {
                handler () {
                    this.getUser();
                },
                deep: true
            },
            '$route': {
                handler () {
                    this.title=null;
                },
                deep: true
            }
        },
        methods: {
            logout ()
            {
                this.$store.dispatch('logout').then(() => {
                    this.$router.replace({ path: '/login' })
                });
            },
            getUser ()
            {
                if (this.$store.getters.isAuthenticated)
                {
                    this.$store.dispatch("getUser");
                    this.$store.dispatch("getUnread");
                } else {
                    this.$store.commit('setUser', {});
                }
            },
        }
    }
</script>
<style lang="scss">
    @import "./styles/index.scss";
    .el-header {
        .logo {
            //margin-left: 0px;
            //margin-right: 25px;
          span {
            padding: 0 15px;
          }
            font-size: 20px;
            img {
                height: 50px;
            }
          a {
            color: #000;
          }
        }
    }
</style>